const BRAND_KEYS = {
  BRANDS: () => ['brands'],
  BRAND: (uid) => ['brands', uid],
};

export default BRAND_KEYS;
